import React from 'react';
import { styled, Button, Grid } from '@mui/material';

const StyledActionsContainer = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'end',
    marginBottom: '32px',
    marginTop: '30px',
    gap: '24px',
    alignItems: 'baseline',
}));

const StyledPurpleButton = styled(Button)(() => ({
    backgroundColor: '#4c17ad',
    padding: '8px 15px',

    '&:disabled': {
        backgroundColor: '#bf9dff ',
        color: 'white',
    },
    '&:hover': {
        backgroundColor: '#4c17ad',
    },
    minWidth: '8px',
    minHeight: '25px',
    color: '#ffffff',
    textTransform: 'none',

    '@media (width <= 850px)': {
        width: '100%',
        justifyContent: 'center',
    },
}));

type SendCSVInvitationsActionsProps = {
    onClickCancelButton: () => void;
    onClickSendAndInviteButton: () => void;
    emailsAmount: number;
};

const SendInvitationListActions: React.FC<SendCSVInvitationsActionsProps> = ({
    onClickCancelButton,
    onClickSendAndInviteButton,
    emailsAmount,
}) => {
    return (
        <Grid
            sx={{
                width: '100%',
            }}
        >
            <StyledActionsContainer
                style={{ display: 'flex', justifyContent: 'space-between' }}
            >
                <Button
                    id="Button-send-invites"
                    size="small"
                    style={{
                        fontSize: '0.75rem',
                        opacity: 1,
                    }}
                    onClick={() => onClickCancelButton()}
                >
                    Cancel
                </Button>
                <StyledPurpleButton
                    variant="contained"
                    id="StyledPurpleButton-send-invites"
                    size="small"
                    style={{ opacity: 1 }}
                    onClick={() => onClickSendAndInviteButton()}
                >
                    {`SEND ${emailsAmount} INVITES`}
                </StyledPurpleButton>
            </StyledActionsContainer>
        </Grid>
    );
};

export default SendInvitationListActions;
